<template>
    <div class="d-flex m-3 gap-2 content">

    <!-- Main Content -->
    <div class="w-80 d-flex flex-column gap-4">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-1">Splash Message</h4>
        <h5 class="text-gray-600 mb-4">Use splash messages in giving users information on what is the result of the process they're into.</h5>
        <h5 class="mt-4 mb-2">How to Use</h5>
        <p class="text-gray-600">To install the Table component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2 mb-3">yarn add @bit/dtt.uic.dtt-splash-message</code>
        <p class="text-gray-600">To use the Table component in your Vue component.</p>
        <code class="bg-gray-100 p-3 mt-2">import DttSplashMessage from '@bit/dtt.uic.dtt-splash-message'</code>
      </div>
      
      <SplashMessageVariants />
      <SplashMessageContents />

      <!-- Props -->
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Props</h4>
        <b-table striped bordered :items="items"></b-table>    
      </div>
    </div>

    <!-- Quick Links -->
    <!-- <div class="pl-3 w-20 d-flex flex-column position-sticky h-100" style="right: 0; bottom: 0; top: 25px;">
      <a
        v-for="(item, index) in styles" :key="index"
        :href="`#${item.link}`"
        class="decoration-none"
      >{{ item.name }}</a>
    </div> -->

  </div>
</template>

<script>
import SplashMessageVariants from '@/components/local/SplashMessage/SplashMessageVariants'
import SplashMessageContents from '@/components/local/SplashMessage/SplashMessageContents'

export default {
  components: { SplashMessageVariants, SplashMessageContents},
  data () {
    return {
      viewMulti: 'preview',
      items: [
        { prop: 'title', type: 'String', default: '', description: 'Set the title of the Splash Message' },
        { prop: 'description', type: 'String', default: '', description: 'Set the description of the Splash Message' },
        { prop: 'time', type: 'String or Number', default: '5000', description: 'Determines the timeout of the Splash Message' },
        { prop: 'variant', type: 'String', default: 'primary', description: '	Applies one of the Dothis.to theme color variants to the component' },
      ],
      // title: this.title,
      //   description: this.description,
      //   variant: this.variant,
      //   time: this.time
    }
  }
}
</script>